import actionTypes from "../actionTypes"


export default {
    request: (params) => ({
        type: actionTypes.LOGIN_REQUEST,
        params,
    }),
    receive: (data) => ({
        type: actionTypes.LOGIN_RECEIVE,
        data,
    }),
    initial: () => ({
        type: actionTypes.LOGIN_INITIAL,
    }),
    failure: (errorMessage) => ({
        type: actionTypes.LOGIN_FAILURE,
        errorMessage
    })
}


